export interface PlatformProduct {
  index: string
  name: string
  audience: string
  items: string[]
  status: 'live' | 'next'
  highlight?: { label: string; note: string }
}

export const engineCapabilities =
  'Voice · Conversation · Memory · Actions · Workflows · Integrations'

export const platformProducts: PlatformProduct[] = [
  {
    index: '01',
    name: 'VEXU App',
    audience: 'AI for individuals & professionals',
    status: 'live',
    items: [
      'AI call handling',
      'Personal communication assistant',
      'Caller experiences',
      'Subscription + usage',
    ],
  },
  {
    index: '02',
    name: 'VEXU Business',
    audience: 'AI communications for businesses',
    status: 'live',
    items: [
      'Voice',
      'WhatsApp',
      'Website AI',
      'Workflows',
      'Integrations',
      'Platform + usage',
    ],
  },
  {
    index: '03',
    name: 'Talab',
    audience: 'Conversational AI for commerce',
    status: 'next',
    items: [
      'AI merchant storefront',
      'Conversational product discovery',
      'Lead generation',
      'Product catalogue',
      'Analytics & reporting',
      'Website / shareable storefront',
    ],
    highlight: {
      label: 'One click → publish to Talab marketplace',
      note: 'A merchant can use its conversational AI experience independently — then extend the same catalogue into the Talab marketplace.',
    },
  },
]

export const customerProgression = [
  'Individual',
  'Professional',
  'Business',
  'Merchant',
]

export const expansionStatement =
  'One platform. Multiple products. Expanding revenue opportunities.'

export const expansionNote =
  'VEXU App and VEXU Business drive the current Base Case. Talab demonstrates how the same AI technology can unlock additional verticals.'

/** Keeps Slide 12's Base Case scope unambiguous. */
export const talabScopeNote =
  'Strategic upside — not included in 3-year projections'
